import StudentSubjectsStatus from '../StudentSubjectsStatus.vue'
import StudentSubjectsStatusTable from '../Views/StudentSubjectsStatusTable.vue'

const StudentSubjectsStatusRoutes = {
    path: '/student-subjects-status',
    meta: {
        name: {
            en: 'Student subjects status list',
            es: 'Listado Alumno Materia'
        }
    },
    component: StudentSubjectsStatus,
    children: [
        {
            path: '/',
            component: StudentSubjectsStatusTable,
            name: 'student_subjects_status_table',
        },
    ]
};

export default StudentSubjectsStatusRoutes
